rs.module("jobs/criteria",

    [ "jobs/schedule-editor" ],

    function (scheduleEditor) {

        function initialize(jsSelectors, constants, jobCommands) {

            var actionButton = $.js(jsSelectors.actionButton);

            // subscribe to events from the schedule editor
            scheduleEditor.subscribe({
                momentChanged: _onMomentChanged
            });

            // moment type has changed
            function _onMomentChanged(selectedMoment) {

                // Based on selected moment, update the command button between immediate execution and scheduling
                //  not using triple equals because constants is a string
                if (selectedMoment == constants.momentNow) {
                    actionButton.html("Run Job");
                    actionButton.val(jobCommands.execute);
                }
                else {
                    actionButton.html("Schedule Job");
                    actionButton.val(jobCommands.schedule);
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);